<div *ngIf="customFields$ | async as fields" [formGroup]="formGroup" class="dynamic-fields-section">
  <mat-expansion-panel [expanded]="true" class="mat-expansion-panel-spacing">
    <mat-expansion-panel-header>
      <mat-panel-title>Custom Fields</mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngIf="fields && fields.length > 0; else noFields">
      <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
        <ng-container *ngFor="let field of fields">
          <div fxFlex="48" *ngIf="!field.IsHidden && getFieldControl(field.FieldName)"
            class="field-with-previous-step-hint"
            [class.field--modified]="isFieldModified(field.FieldName)">
            <app-dynamic-field
              [field]="field"
              [externalFormControl]="getFieldControl(field.FieldName)!"
            ></app-dynamic-field>
            <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue(field.FieldName) as text">
              {{ text }}
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #noFields>
      <div class="no-fields-message">
        <p>No custom fields available for this section.</p>
      </div>
    </ng-template>
  </mat-expansion-panel>
</div>
